
import { rem } from 'polished';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { TextParagraph, media, spacing } from '../../theme';
import colors from '../../theme/variables/colors';
import SmileIcon from '../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-smile.svg'
import { FormSectionElements, ProgramContainer } from '../../entities/formTemplateDataType';
import { FeedbackStatus } from '../../entities/Constants';
import { setParam } from '../../utilities/URLUtils';

export const FeedbackContainer = styled.div`
    max-width: ${props => props.lang==='en' ? rem(650) : rem(890)};
    width: 100%;
    display: flex;
    background-color: ${colors.palette.greyscale5};
    align-items: flex-start;
    padding: ${spacing.spacing5};
    margin-top: ${spacing.spacing5};
    margin-bottom: ${spacing.spacing7};
    border: 1px solid ${colors.palette.greyscale20};

    svg {
        margin-right: ${spacing.spacing3};
        width: 64px;

        @media ${media.small} {
            width: 45px;
        }
    }

    @media (max-width: ${props => props.lang === 'en' ? 768: 950}px ) {
        max-width: ${props => props.lang==='en' ? rem(360) : rem(550)};
    }
`;

const FeedbackContent = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: ${spacing.spacing4};
`;
const FeedbackButton = styled.div`
    width: 100%;
    max-width: ${props => props.lang === 'en' ? '250px' : '350px'};
    height: 48px;
    border-radius: 4px;
    border: 2px solid #0066CC;
    background-color: #FFFFFF;
    color: #0066CC;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0 0.5rem;
`;
const StyledTextParagaraph = styled(TextParagraph)`
    margin: ${spacing.spacing0};
    white-space: nowrap;
`;

export default function FeedbackComponent({
    programContainer,
    isEng,
    field,
    status,
    code,
    transactionId,
}: {
    programContainer?: ProgramContainer;
    field?: FormSectionElements;
    isEng?: boolean;
    status?: string;
    code?: string;
    transactionId?: string;
}) {
    
    const [feedbackUrl, setFeedbackUrl] = useState<string>('');
        let url = ''; 
    useEffect(() => {

        // if (field) {
        const sts = status || field?.feedback?.status || FeedbackStatus.Success;
        const cd = code || field?.feedback?.code || FeedbackStatus.Failed;


        if (programContainer.Profile?.email) {
            url = isEng ? (field?.FeedbackURL_CXP || programContainer?.FeedbackURL_CXP) : (field?.FeedbackURLFRA_CXP || programContainer?.FeedbackURLFRA_CXP);
        }
        if (!url) {
            url = isEng ? (field?.FeedbackURL || programContainer?.FeedbackURL) : (field?.FeedbackURLFRA || programContainer?.FeedbackURLFRA);
        }

        if (url) {
            url= setParam(url, 'cxpuser', `${programContainer.Profile?.email ? 'yes' : 'no'}`);
            url = setParam(url, 'sts', sts);
            url = setParam(url, 'code', status === FeedbackStatus.Success ? null : cd);
            url = setParam(url, 'tid', transactionId);
        }
        setFeedbackUrl(url);
    }, [field, isEng, programContainer?.Profile]);
    
  
    
    return (
        <FeedbackContainer lang={isEng ? 'en' : 'fr'}>
            <img src={SmileIcon} alt="Smile Icon" style={{ marginRight: '0.5rem', marginTop:'0.5rem', alignItems:'center' }} />
            <FeedbackContent>
                <div style={{whiteSpace: 'normal'}}>{isEng ? 'How was your experience today' : 'Comment s’est déroulée votre expérience aujourd’hui'}?</div>
                <FeedbackButton lang={isEng ? 'en' : 'fr'}
                    onClick={() => window.open(feedbackUrl, '_blank', 'noopener,noreferrer')}
                >
                    {isEng ? "Share your feedback" : "Faites-nous part de vos commentaires"}
                </FeedbackButton>
            </FeedbackContent>
        </FeedbackContainer>
    );
}
